import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { Box } from '@/components/Box';
import { Button } from '@/components/Button';
import { Modal } from '@/components/Modal';
import { Typography } from '@/components/Typography';
import * as CM from '@/messages/common';
import * as PM from '@/messages/payment';

export type ReturnConfirmSubmitModalProps = {
  isOpen: boolean;
  isSubmitting: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
};

export const ReturnConfirmSubmitModal: FC<ReturnConfirmSubmitModalProps> = ({
  isOpen,
  isSubmitting,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal
      data-test-id='OrderReturnViewReturnConfirmModal'
      ecsClose={!isSubmitting}
      gutters
      isOpen={isOpen}
      maxWidth='sm'
      onClose={isSubmitting ? undefined : onClose}
      screenClose={!isSubmitting}
    >
      <Modal.Header divider onClose={isSubmitting ? undefined : onClose}>
        <FormattedMessage {...PM.paymentMessages.returnSubmitConfirmTitle} />
      </Modal.Header>
      <Modal.Body>
        <Typography
          color='secondaryGrey'
          scale='p2'
          style={{ padding: '1rem' }}
          textAlign='center'
        >
          <FormattedMessage
            {...PM.paymentMessages.returnSubmitConfirmDescription}
          />
        </Typography>
      </Modal.Body>
      <Modal.Footer
        data-test-id='OrderReturnViewReturnConfirmFooter'
        isFullWidthMobile={false}
      >
        <Box marginTop={2}>
          <Button
            data-test-id='OrderReturnViewReturnConfirmCancel'
            disabled={isSubmitting}
            isFullWidth
            onClick={onClose}
            variant='outlined'
          >
            <FormattedMessage {...CM.commonMessages.cancel} />
          </Button>
        </Box>
        <Box marginTop={2}>
          <Button
            data-test-id='OrderReturnViewReturnConfirmSubmit'
            disabled={isSubmitting}
            isFullWidth
            isProcessing={isSubmitting}
            onClick={() => {
              Promise.resolve(onConfirm()).catch(() => null);
            }}
            type='button'
          >
            <FormattedMessage {...CM.commonMessages.confirm} />
          </Button>
        </Box>
      </Modal.Footer>
    </Modal>
  );
};
